/*eslint backbone/no-constructor:0 */
define('glu/grid/filter/textSearch',['require','./fieldSearch','../../util','../../collection','hbs!./textSearch.hbs'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch'),
        util = require('../../util'),
        Collection = require('../../collection'),
        tpl = require('hbs!./textSearch.hbs');

    function filterableColumns(column) {
        return column.get('filterable') !== false;
    }

    return FieldSearch.extend({
        template: tpl,

        initialize: function() {
            FieldSearch.prototype.initialize.apply(this, arguments);
            if (this.options.model) {
                this.setField(this.options.model.get('field'));
            }
        },

        serializeData: function() {
            var items;
            if (this.model && this.collection) {
                items = new Collection(this.collection.filter(filterableColumns));
                var obj = this.model.toJSON();
                obj.items = items.toJSON();
                return obj;
            } else if (this.collection) {
                items = new Collection(this.collection.filter(filterableColumns));
                return {
                    items: items.toJSON()
                };
            } else {
                return FieldSearch.prototype.serializeData.call(this);
            }
        },

        handleSubmit: function(e) {
            e.preventDefault();

            var filter = this.createFilter();

            try {
                this.trigger('filter', filter);
            } catch (ex) {
                return false;
            }

            return false;
        },

        createFilter: function() {
            return this.buildFilter(this.model.get('field'), this.ui.$focusField.val());
        },

        buildFilter: function(field, value) {
            return {
                title: this.model.get('title'),
                label: value,
                value: value,
                type: this.model.get('type') || 'string',
                field: field || this.model.get('field'),
                filter: util.bind(this.filter, this, this.field || field, value)
            };
        },

        onRender: function() {
            FieldSearch.prototype.onRender.apply(this, arguments);

            if (this.field && this.collection && this.collection.length > 0) {
                var field = this.field;
                var opt = this.ui.$fieldSelect.find('option[value=\'' + field + '\']');
                opt.attr('selected', 'selected');
            }
        },

        setField: function(field) {
            this.field = field;
            this.className = this.className || 'field-set';
        },

        unsetField: function() {
            delete this.field;
        },

        filter: function(field, value, model) {
            var modelVal = model.get(field);

            if (util.isNumber(modelVal) || util.isString(modelVal)) {
                modelVal = (modelVal + '').toLowerCase(); // make sure numbers are searched as strings
            } else {
                return false; // model does not have that field in a searchable form
            }

            if (util.isString(value) || util.isNumber(value)) {
                value = (value + '').toLowerCase();
            }

            return modelVal.indexOf(value) > -1;
        }
    });
});

